import { request } from 'redukers'

export const getIsUploadInvoiceRequesting = (state) => request.getIsRequesting(state.invoice.uploadInvoice)

export const getIsUploadInvoiceSuccess = (state) => request.getIsRequestSucceeded(state.invoice.uploadInvoice)

export const getIsUploadInvoiceError = (state) => request.getIsError(state.invoice.uploadInvoice)

export const getInvoiceData = (state) => state.invoice.data
